import Vue from "vue";
import gridMap from "../map/gridMap.vue";
import * as weibo from "../../../static/json/weibo.json";
//模块：首页
export default Vue.extend({
    name: "index",
    components: {
        gridMap: gridMap
    },
    data: function () {
        return {
            meteType: 0,
            funType: 0,
            time: (new Date()).getTime() - 60 * 3 * 1000 * 10,
            weiboList: weibo['data'].list,
            windwidth: 1200,
        };
    },
    beforeMount: function () {
        this.windwidth = window.innerWidth;
        var self = this;
        onresize = function () {
            self.windwidth = window.innerWidth;
        };
    },
    mounted: function () {
    },
    methods: {
        toPage: function (path) {
            this.$router.push(path);
            // this.$route.path=path;
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/iview-loader??ref--0-1!./src/sfc/home/index.vue
// module id = null
// module chunks = 